import type { PlatformInfo } from '@erp/native/interfaces';

export function detectWebPlatform(): PlatformInfo {
  return {
    platform: 'web',
    isDesktop: false,
    appVersion:
      (import.meta as { env?: Record<string, string> }).env?.VITE_APP_VERSION ??
      '0.0.0-web',
    locale:
      typeof navigator !== 'undefined' ? navigator.language : undefined,
  };
}
